import LabelProvider from "core/components/label/LabelProvider";


export default LabelProvider.create({

	Issued: {
		k: "certificate.issueDate",
		v: "Issued ${date}",
		argNames: ["date"]
	},
    NoEarnedCertificates:{
        k: "certificates.noresults.title",
        v: "No Earned Certificates Found"
    },
    NoEarnedCertificatesDescription:{
        k:"certificates.noresults.description",
        v:"Try different search parameters"
    },
    CertificateDownload: {
        k: "certificate.download",
        v: "Download"
    }

});



// WEBPACK FOOTER //
// ./src/panels/userCertificates/UserCertificates.labels.ts